import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";
import ItemsCarousel from 'react-items-carousel';
import ViewTableroProductos from "./ViewTableroProductos";
import InputRange from 'react-input-range';



const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };

class TableroMainPage extends Component {
  constructor(props) {
    super(props);
    this.__getProgreso = this.__getProgreso.bind(this)
    this.state = {
      __getProgreso: this.__getProgreso,
      isLoading: true,
      optViewBy: 'compras',
      optTypeBy: 'categoria',
      // finit: moment().clone().weekday(1).format('YYYY-MM-DD'),
      // ffin: moment().clone().weekday(7).format('YYYY-MM-DD'),
      finit: '2021-06-01',
      ffin: '2021-06-30',
      arrTableroOptions: [
        { value: 'COMPRAS', label: 'COMPRAS', optViewBy: 'compras', },
        { value: 'VENTAS',  label: 'VENTAS',   optViewBy: 'ventas', },
        { value: 'GASTOS',  label: 'GASTOS',  optViewBy: 'gastos', },
        { value: 'SALIDAS', label: 'SALIDAS',   optViewBy: 'salidas', },
        { value: 'GENERAL', label: 'GENERAL',   optViewBy: 'general', },
        { value: 'BÁSCULA', label: 'BÁSCULA',   optViewBy: 'bascula', },
      ],
      arrTypeInfo: [
        { value: 'POR CATEGORIA',   label: 'POR CATEGORIA',   optTypeBy: 'categoria', },
        { value: 'POR PRODUCTO',   label: 'POR PRODUCTO',   optTypeBy: 'producto', },
      ],
      // arrTableroOptions: [
      //   { value: 'Indicador por productos',  label: 'Indicador por productos',  optViewBy: 'productos', },
      //   { value: 'Indicador por categorías', label: 'Indicador por categorías', optViewBy: 'categoria', },
      //   { value: 'Indicador por sucursal',   label: 'Indicador por sucursal',   optViewBy: 'sucursal', },
      // ],
      arrFiltroVer: [
        { optFiltroVer: 'dia', value: 'Día', active: 0, },
        { optFiltroVer: 'semana', value: 'Semana', active: 1, },
        { optFiltroVer: 'mes', value: 'Mes', active: 0, },
      ],

      filterBy: 'listaProductos',
      arrProductos: [],
      arrCategorias: [],
      arrSucursales: [
        {id_sucursal: '5f206899a20c8', nombre: 'CD VALLES', label: 'CD VALLES', value: 'CD VALLES', },
      ],
      id_producto_selected: '',
      indexProducto: -1,
      indexCategoria: -1,
      indexSucursal: -1,
      arrProductosMetadata: {venta: [],},
      arrCategoriasMetadata: [],
      arrSucursalesMetadata: [],

      valueLarge: { min: 1, max: 30 },

      //Graphs
      arrKG: [],
      arrCredito: [],
      arrAcumKG: [],
      arrAcumCredito: [],
      arrVentaPesos: [],
      arrAcumVentaPesos: [],

      typeGraph: 1,

    }
  }

  __getProgreso() {
    console.log('updated info')
    // this.goToGeneral()
  }

  componentDidMount() {
    this.goToGeneral()
    this.props.onRef(this)
  }

  render() {
    const { arrTypeInfo, arrTableroOptions, arrSucursales, arrFiltroVer, isLoading, finit, ffin, optTypeBy, optViewBy, valueLarge, } = this.state
    const { arrSucursalSelected } = this.props.initState

    if(isLoading) {
      return (
        <div className="directorPage__wrapper" style={{ marginTop: 150, }}>
          {<Lottie
            direction={1}
            options={{
              animationData: animationData,
              loop: true,
            }}
            />}
        </div>
      )
    }

    return (
      <Container className="directorPage__wrapper"  style={{ paddingTop: 20, paddingBottom: 20, }}>
        {/* Principal Container */}
        <>
          
          <p className="regVentaPage__productGeneral" style={{ padding: 0, margin: 0, }}>TABLERO DE PRODUCCIÓN</p>
          <Select
            placeholder="COMPRAS"
            options={arrTableroOptions}
            onChange={(val) => { const optViewBy = val.optViewBy; this.setState({ optViewBy }) }}
            styles={customStyles}
          />
          <Select
            placeholder="POR CATEGORIA"
            options={arrTypeInfo}
            onChange={(val) => { const optTypeBy = val.optTypeBy; this.setState({ optTypeBy }) }}
            styles={customStyles}
          />

          <Row style={{ marginTop: 5, }}>{
            arrFiltroVer.map((t, e) => (
              <Col>
                <p
                  style={{
                    padding: '5px 10px', marginTop: 15, cursor: 'pointer', textAlign: 'center', borderRadius: '4px', fontWeight: 600, width: '100%', margin: '4px 0',
                    background: t.active === 1 ? '#2980b9' : 'transparent', border: t.active === 1 ? '0px' : '1px solid #2980b9',
                    color: t.active === 1 ? '#fff' : '#2980b9',
                  }}
                  onClick={ () => {
                    this.onChangeFiltroVer(t,e)
                  }} className="regVentaPage__title">{t.value}
                </p>
              </Col>
            ))
          }</Row>

          <Row>
            <Col>
              <p style={{ margin: 0, }}>Desde</p>
              <input type={"date"}
                value={finit}
                onChange={(event) => {
                  arrFiltroVer.map(( t => t.active = 0) );
                  this.setState({ finit: event.target.value, arrFiltroVer });
                }}
                style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
              />
            </Col>
            {
              arrFiltroVer[0].active != 1 ? (
                <Col>
                  <p style={{ margin: 0, }}>Hasta</p>
                  <input type={"date"}
                    value={ffin}
                    onChange={(event) => {
                      arrFiltroVer.map(( t => t.active = 0) );
                      valueLarge.max = event.target.value
                      this.setState({ ffin: event.target.value,
                        arrFiltroVer,
                        valueLarge,

                      });
                    }}
                    style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
                  />
                </Col>
              ) : null
            }
          </Row>
          <Row>
            <Col>
              <button style={{ margin: 0, marginTop: 5, }} className={'btn btn-primary'} onClick={() => { this.goToGeneral() }}>Generar</button>
            </Col>
          </Row>

          <hr />
          {
            optTypeBy === 'producto'
            ?
              <ViewTableroProductos
                initState={this.props.initState} initsetState={ (param) => this.props.initsetState(param)}
                mainState={this.state} mainsetState={(param, c) => {this.setState(param, c)}}
                maingetGeneral={() => { this.goToGeneral() }}
                generateInfoArrayBar= {() => {this.generateInfoArrayBar()} }
              />
            : null
        }
          

        </>

      </Container>
    )
  }

  onChangeFiltroVer(t, e) {
    let { arrTableroOptions, arrFiltroVer, isLoading, finit, ffin, valueLarge, } = this.state

    arrFiltroVer.map(( t => t.active = 0) );
    arrFiltroVer[e].active = 1

    if( t.optFiltroVer == 'semana' ) {
      let now = moment( finit );
      finit = now.clone().weekday(1).format('YYYY-MM-DD')
      ffin  = now.clone().weekday(7).format('YYYY-MM-DD')
    } else if(t.optFiltroVer == 'mes') {
      let now = moment( finit );
      finit  = now.startOf('month').format('YYYY-MM-DD')
      ffin  = now.endOf('month').format('YYYY-MM-DD')
    }

    this.setState({ arrFiltroVer, finit, ffin }, this.goToGeneral);
  }

  goToGeneral() {
    let { optViewBy, optTypeBy, finit, ffin,
      indexProducto, indexCategoria, indexSucursal,
      arrProductos, arrCategorias, arrSucursales, valueLarge,
    } = this.state
    this.setState({ isLoading: false, })

    // if(optTypeBy === 'todos') {
    //   const data = {}
    //   fetch(this.getURLByOPT('getListadoByType'), this.headersPOST({...data}))
    //   .then(response => response.json())
    //   .then((response) => {
    //     console.log(response)
    //   })
    // } else {
    //   return false
    // }


    if(indexProducto == -1 && indexCategoria == -1 && indexSucursal == -1) {

      return false;
    }


    let data = {
      id_producto: indexProducto > -1 ? arrProductos[indexProducto].id_producto : ''  ,
      id_categoria: indexCategoria > -1 ? arrCategorias[indexCategoria].id_categoria : ''  ,
      id_sucursal: indexSucursal > -1 ? arrSucursales[indexSucursal].id_sucursal : ''  ,
      date_start: finit,
      date_end: ffin,
    }


    fetch(this.getURLByOPT('getVentaKg'), this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      if(indexProducto > -1) {
        valueLarge.max = response.venta.length
        this.setState({ arrProductosMetadata: response, valueLarge, arrKG: [], })


        setTimeout(() => {
          this.generateInfoArrayBar().then((res) => {
            console.log('generando barrita', res)
          }).catch((err) => {
            console.log('ERR', err)
          })
        }, 1000)




      } else if(indexCategoria > -1) {
      } else if(indexSucursal > -1) {
      }

    })

  }



  generateInfoArrayBar() {
    let { arrProductosMetadata, valueLarge , } = this.state
    let { min, max } = valueLarge;

    let arrKG = [], arrCredito = [],
    arrAcumKG = [], arrAcumCredito = [],
    arrVentaPesos = [], arrAcumVentaPesos = []

    return new Promise((resolve, reject) => {

      while( min <= max ) {
        arrKG.push({ 'x': (moment(arrProductosMetadata.venta[(min - 1)].fecha).format('DD/MM')), 'y': arrProductosMetadata.venta[(min - 1)].kg  })
        arrAcumKG.push({ 'x': (moment(arrProductosMetadata.venta[(min - 1)].fecha).format('DD/MM')), 'y': arrProductosMetadata.venta[(min - 1)].total_kg  })

        arrCredito.push({ 'x': (moment(arrProductosMetadata.venta[(min - 1)].fecha).format('DD/MM')), 'y': arrProductosMetadata.venta[(min - 1)].credito  })
        arrAcumCredito.push({ 'x': (moment(arrProductosMetadata.venta[(min - 1)].fecha).format('DD/MM')), 'y': arrProductosMetadata.venta[(min - 1)].total_credito  })

        arrVentaPesos.push({ 'x': (moment(arrProductosMetadata.venta[(min - 1)].fecha).format('DD/MM')), 'y': arrProductosMetadata.venta[(min - 1)].venta_pesos  })
        arrAcumVentaPesos.push({ 'x': (moment(arrProductosMetadata.venta[(min - 1)].fecha).format('DD/MM')), 'y': arrProductosMetadata.venta[(min - 1)].total_pesos  })


        if(min == max) {
          this.setState({
            arrKG,
            arrAcumKG,
            arrCredito,
            arrAcumCredito,
            arrVentaPesos,
            arrAcumVentaPesos,
          })
          resolve('ok')
        }
        min++
      }
      /*
      for(var a in arrProductosMetadata.venta) {
        // arrAcumCobranza.push({'x':e.mes_nombre_corto, 'y': e.acumulado_cobranza})
        arrKG.push({ 'x': (moment(arrProductosMetadata.venta[a].fecha).format('DD/MM')), 'y': arrProductosMetadata.venta[a].kg  })
        arrAcumKG.push({ 'x': (moment(arrProductosMetadata.venta[a].fecha).format('DD/MM')), 'y': arrProductosMetadata.venta[a].total_kg  })


        if(a == (arrProductosMetadata.venta.length - 1)) {
          this.setState({
            arrKG,
            arrCredito,
            arrAcumKG,
            arrAcumCredito,
          })
          resolve('ok')
        }
      }
      */

    })
  }

  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getStyleModal(opt) {
    if(opt === 'isOpenViewInfoCortes') {
      return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '50%',height: '70%',} };
    }

    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3','#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3']
    return color[e]
  }


  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

 getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/${PHP}?opt=${opt}`
  }


}

export default withRouter(TableroMainPage)